import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { readCookie } from "../../helpers/cookie-helper";
import { stringToObject } from "../../helpers/object-helper";
export interface AppState {
  id: string;
  name: string;
  schema: object;
  navigationItems: object[];
  isDrawerShown: boolean;
  loadingStatus: "none" | "loading" | "failed" | "done";
}

const initialState: AppState = {
  id: "",
  name: "",
  schema: {},
  navigationItems: [],
  isDrawerShown: false,
  loadingStatus: "none",
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    toggleDrawer: (state: AppState) => {
      state.isDrawerShown = !state.isDrawerShown;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadAppSchema.pending, (state) => {
        state.loadingStatus = "loading";
      })
      .addCase(loadAppSchema.fulfilled, (state, action) => {
        state.loadingStatus = "done";
        state.id = action.payload.id;
        state.name = action.payload.name;
        state.navigationItems = action.payload.navigationItems;
        state.schema = action.payload.schema;
      })
      .addCase(loadAppSchema.rejected, (state) => {
        state.loadingStatus = "failed";
      });
  },
});

// Actions

export const { toggleDrawer } = appSlice.actions;

// ----------------------------------------------------------------------

export const loadAppSchema = createAsyncThunk("app/loadAppSchema", async () => {
  const cookieValue = readCookie("user");
  const user = stringToObject(cookieValue);
  const accessToken = user ? user.accessToken : "";
  const apiURL = `${process.env.REACT_APP_UI_API}/apps/schema`;
  const axiosConfig = {
    method: "get",
    url: apiURL,
    headers: {
      Authorization: `bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    data: {},
  };
  const response = await axios(axiosConfig);

  return response.data;
});

export default appSlice.reducer;
